module.exports = __webpack_public_path__ + "static/img/花瓶6.7167038.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶6.png
// module id = 2CEr
// module chunks = 2